import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=06460064&scoped=true"
import script from "./ModalFeedback.vue?vue&type=script&lang=js"
export * from "./ModalFeedback.vue?vue&type=script&lang=js"
import style0 from "./ModalFeedback.vue?vue&type=style&index=0&id=06460064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06460064",
  null
  
)

export default component.exports